import { BiMoney } from "react-icons/bi";
import { FaGraduationCap, FaNairaSign } from "react-icons/fa6";
import { IoIosNotificationsOutline } from "react-icons/io";
import studentData from "../../../data/data.json";
const Parents = () => {
    // Sample data
    const data = [
        { id: '#0021', expense: 'Exam Fees', amount: '$150.00', status: 'Paid', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0023', expense: 'Exam Fees', amount: '$150.00', status: 'Paid', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0024', expense: 'Exam Fees', amount: '$150.00', status: 'Due', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0025', expense: 'Exam Fees', amount: '$150.00', status: 'Paid', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0027', expense: 'Exam Fees', amount: '$150.00', status: 'Paid', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0022', expense: 'Semester Fees', amount: '$350.00', status: 'Due', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
        { id: '#0026', expense: 'Semester Fees', amount: '$350.00', status: 'Due', email: 'akkhorschool@gmail.com', date: '22/02/2019' },
    ];
    const Notfi = [
        {
            date: "16 June, 2019",
            text: "Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.",
            author: "Jennyfar Lopez",
            timeAgo: "5 min ago",
        },
        {
            date: "16 June, 2019",
            text: "Great School manag printing.",
            author: "Jennyfar Lopez",
            timeAgo: "5 min ago",
        },

    ];

    return (
        <>

            <div className="bg-gray-100 px-4">

                <div className="mt-8 mb-8">
                    <h1 className="text-xl font-bold">Admin Dashboard</h1>
                    <span className="flex ">
                        <h2>Home &gt; </h2><h2 className="text-yellow-600">Parents</h2>
                    </span>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 md:items-center space-y-4 md:space-x-3 px-4 ">

                    <div className="flex justify-between bg-white py-8 px-2 md:px-4">
                        <span className="bg-red-200 rounded-full">
                            <BiMoney className="text-4xl m-2 text-red-600" />
                        </span>

                        <span>
                            <h2 className="text-gray-500">Due Fees</h2>
                            <span className="flex place-items-center">
                                <FaNairaSign />
                                <h2>150000</h2></span>
                        </span>
                    </div>

                    <div className="flex justify-between bg-white py-8  px-2 md:px-4">
                        <span className="bg-purple-200 rounded-full">
                            <IoIosNotificationsOutline className="text-4xl m-2 text-purple-600" />
                        </span>
                        <span>
                            <h2 className="text-gray-500">Notifications</h2>

                            <h2>3</h2>

                        </span>
                    </div>

                    <div className="flex justify-between bg-white py-8 px-2 md:px-4">
                        <span className="bg-orange-200 rounded-full">
                            <FaGraduationCap className="text-4xl m-2 text-orange-600" />
                        </span>
                        <span>
                            <h2 className="text-gray-500">Result</h2>
                            <h2>16</h2>
                        </span>
                    </div>

                    <div className="flex justify-between bg-white py-8 px-2 md:px-4">
                        <span className="bg-blue-200 rounded-full">
                            <BiMoney className="text-4xl m-2 text-blue-600" />
                        </span>
                        <span>
                            <h2 className="text-gray-500">Expenses</h2>
                            <span className="flex place-items-center"><FaNairaSign />  <h2>1930000</h2></span>                        </span>
                    </div>

                </div>


                <div className="bg-white md:pb-8 px-4 mt-12">
                    <span className="flex  justify-between pt-8 pb-4 md:pb-12">
                        <h1>My Kids</h1>
                        <span>...</span>
                    </span>
                    <div className="md:px-32 md:flex md:justify-between">
                        {studentData.map(st => (
                            <div key={st.admissionId} className='md:flex justify-between  md:space-x-8' >
                                <div>
                                    <img src={st.image} alt={st.name} className="mx-auto mt-4 rounded-full w-24" />
                                </div>


                                <div className=" px-8 py-2 pt-8">
                                    <span className="flex justify-between">
                                        <h2>Name:</h2>
                                        <h2>{st.name}</h2>
                                    </span>

                                    <span className="flex justify-between">
                                        <h2>Gender:</h2>
                                        <h2>{st.gender}</h2>
                                    </span>
                                    <span className="flex justify-between">
                                        <h2>Class:</h2>
                                        <h2>{st.className}</h2>
                                    </span>
                                    <span className="flex justify-between">
                                        <h2>Roll:</h2>
                                        <h2>{st.roll}</h2>
                                    </span>
                                    <span className="flex justify-between">
                                        <h2>Section:</h2>
                                        <h2>{st.section}</h2>
                                    </span>
                                    <span className="flex justify-between">
                                        <h2>Admission Id:</h2>
                                        <h2>{st.admissionId}</h2>
                                    </span>
                                    <span className="flex justify-between">
                                        <h2>Admission Date:</h2>
                                        <h2>{st.admissionDate}</h2>
                                    </span>
                                </div>
                            </div>
                        ))}
                        <div>



                        </div>



                    </div>


                </div>


                <div className=" mt-16 bg-white px-4 pb-8">
                    <span className="flex justify-between">
                        <h1 className="font-bold text-xl md:py-4 py-2 max-[760px]:pt-4 place-items-center">All Expenses</h1>
                        <h1>...</h1>
                    </span>
                    <div className="md:flex md:justify-between">
                        <form className="md:flex-1 flex flex-col md:flex-row space-y-2 px-6 md:justify-between">
                            <input type="text" placeholder="Search by exam"
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            <input type="text" placeholder='Search by Subject'
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            <input type="text" placeholder="dd/mm/yyy"
                                className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                        </form>
                        <button className="bg-yellow-500 max-[760px]:mt-8  max-[760px]:w-full  text-white py-4 md:px-8 ">SEARCH</button>
                    </div>





                    <div className="bg-white w-full pt-8 mt-8 flex  ">


                        <div className="container mx-auto p-6 overflow-x-scroll">
                            <table className="w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr>
                                        <th className="border border-gray-300 px-4 py-2">ID</th>
                                        <th className="border border-gray-300 px-4 py-2">Expense</th>
                                        <th className="border border-gray-300 px-4 py-2">Amount</th>
                                        <th className="border border-gray-300 px-4 py-2">Status</th>
                                        <th className="border border-gray-300 px-4 py-2">E-Mail</th>
                                        <th className="border border-gray-300 px-4 py-2">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td className="border border-gray-300 px-4 py-2">{item.id}</td>
                                            <td className="border border-gray-300 px-4 py-2">{item.expense}</td>
                                            <td className="border border-gray-300 px-4 py-2">{item.amount}</td>
                                            <td className="border border-gray-300 px-4 py-2">{item.status}</td>
                                            <td className="border border-gray-300 px-4 py-2">{item.email}</td>
                                            <td className="border border-gray-300 px-4 py-2">{item.date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>





                        {/* {    <span>
                            <h1>Previous</h1>
                            <button>1</button>
                            <button>Next</button>
                        </span>} */}
                    </div>
                </div>






                <div className="bg-gray-200  px-4 mt-8">

                    <div className=" px-4 bg-white py-4 space-y-4 overflow-y-scroll max-h-[400px]">
                        <div className="flex justify-between pt-4 pb-2 place-items-center">
                            <h2 className="text-xl ">Notifications</h2>
                            <h2>...</h2>
                        </div>
                        {Notfi.map((item, index) => (
                            <div key={index} className='border-b-2 border-gray-300 space-y-2'>
                                <h3
                                    className="bg-blue-400 text-white text-sm rounded-3xl w-fit px-2 py-2">
                                    {item.date}</h3>
                                <p>
                                    {item.text}
                                </p>
                                <span className="flex space-x-2 text-sm">
                                    <h4 className="text-gray-700">{item.author}</h4>
                                    <h4 className="text-gray-500">/ {item.timeAgo}</h4></span>
                            </div>
                        ))}

                    </div>


                </div>


                <div className="bg-white mt-12 mx-4">

                    <div className="px-2">
                        <span className="flex justify-between md:py-4 max-[760px]:pt-4 py-4 place-items-center">
                            <h1 className="font-bold text-xl   ">All Expenses</h1>
                            <h1>...</h1>
                        </span>
                        <div className="md:flex md:justify-between">
                            <form className="md:flex-1 flex flex-col md:flex-row space-y-2 px-6 md:justify-between">
                                <input type="text" placeholder="Search by exam"
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                                <input type="text" placeholder='Search by Subject'
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                                <input type="text" placeholder="dd/mm/yyy"
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            </form>
                            <button className="bg-yellow-500 max-[760px]:mt-8  max-[760px]:w-full  text-white py-4 md:px-8 ">SEARCH</button>
                        </div>
                    </div>



                    <div className="container overflow-x-scroll mx-auto mt-10">
                        <table className=" w-full table-auto border-collapse border">
                            <thead>
                                <tr>
                                    <th className="border px-4 py-2">ID</th>
                                    <th className="border px-4 py-2">Exam Name</th>
                                    <th className="border px-4 py-2">Subject</th>
                                    <th className="border px-4 py-2">Class</th>
                                    <th className="border px-4 py-2">Roll</th>
                                    <th className="border px-4 py-2">Grade</th>
                                    <th className="border px-4 py-2">Percent</th>
                                    <th className="border px-4 py-2">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2">Class Test</td>
                                    <td className="border px-4 py-2">English</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">#0045</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">99.00 &gt; 100</td>
                                    <td className="border px-4 py-2">22/02/2019</td>
                                </tr>
                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2">Class Test</td>
                                    <td className="border px-4 py-2">English</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">#0045</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">99.00 &gt; 100</td>
                                    <td className="border px-4 py-2">22/02/2019</td>
                                </tr>
                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2">Class Test</td>
                                    <td className="border px-4 py-2">English</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">#0045</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">99.00 &gt; 100</td>
                                    <td className="border px-4 py-2">22/02/2019</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>



                </div>



            </div>

        </>
    );
}

export default Parents;